import { create } from 'zustand';

export type ZstdFooter = {
  setShowInfoPopup: (v: boolean) => void;
  showInfoPopup: boolean;
  setShowChatbotTermsPopup: (v: boolean) => void;
  showChatbotTermsPopup: boolean;
  setFooterTop: (v: number) => void;
  footerTop: number;
  setFooterHeight: (v: number) => void;
  footerHeight: number;
  footerIsInViewport: boolean;
  setFooterIsInViewport: (v: boolean) => void;
  footerIsIntersecting: boolean;
  setFooterIsIntersecting: (v: boolean) => void;
};
export const useZstdFooter = create<ZstdFooter>((set) => ({
  setShowInfoPopup: (v: boolean) => set({ showInfoPopup: v }),
  showInfoPopup: false,
  setShowChatbotTermsPopup: (v: boolean) => set({ showChatbotTermsPopup: v }),
  showChatbotTermsPopup: false,
  setFooterTop: (v: number) => set({ footerTop: v }),
  footerTop: 0,
  setFooterHeight: (v: number) => set({ footerHeight: v }),
  footerHeight: 0,
  footerIsInViewport: false,
  setFooterIsInViewport: (v: boolean) => set({ footerIsInViewport: v }),
  footerIsIntersecting: false,
  setFooterIsIntersecting: (v: boolean) => set({ footerIsIntersecting: v }),
}));
